<template>
  <AppModal @close="onClose()" v-bind="$attrs" v-if="visible">
    <template v-slot:header>Update IDT Number</template>
    <form @submit.prevent="onSubmit()">
      <b-alert v-if="currentIDTNumber && currentIDTNumber !== null" variant="warning" show>
        An IDT number already exists. Adding a new one will overwrite the existing number.<br>The current IDT number is {{ currentIDTNumber }}
      </b-alert>

      <div class="form-group">
        <label for="idtNumber">IDT Number</label>
        <input
          :class="{'is-invalid': $v.idtNumber.$invalid && isValidating}"
          class="form-control" 
          v-model="idtNumber" 
        />
        <transition name="fade">
          <AppNotification type="danger" v-if="!$v.idtNumber.required && isValidating">
            Field is required
          </AppNotification>
        </transition>
      </div>
    </form>

    <template v-slot:footer>
      <button :disabled="isSubmitting" @click.prevent="onSubmit()" class="btn btn-primary" type="submit">
        Submit
      </button>
      <button :disabled="isSubmitting" @click="onClose()" class="btn btn-danger" type="button">
        Close
      </button>
    </template>
  </AppModal>
</template>

<script>
import AppNotification from "@/components/shared/AppNotification";
import AppModal from "@/components/shared/AppModal";
import InterdepartmentalTransfersService from "@/services/InterdepartmentalTransfersService";
import { required } from "vuelidate/lib/validators";
import { ToastType } from "@/services/models/shared/ToastType";

export default {
  components: {
    AppNotification,
    AppModal
  },
  data() {
    return {
      idtNumber: null,
      isSubmitting: false,
      isValidating: false
    };
  },
  props: {
    visible: {
      type: Boolean,
      required: false,
      default: false
    },
    currentIDTNumber: {
      type: String,
      required: false
    },
    idtNumberId: {
      type: String,
      required: true
    }
  },
  methods: {
    async onSubmit() {
      this.isValidating = true;
      
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.isSubmitting = true;
      InterdepartmentalTransfersService.updateIDTNumber({ id: this.idtNumberId, number: this.idtNumber })
        .then(() => {
          this.alert(ToastType.Success, "IDT Number added successfully");
          this.onClose();
        })
        .catch(() => {
          this.alert(ToastType.Danger, "Unable to update IDT number");
        })
        .finally(() => {
          this.onClose();
        });
    },

    resetModal() {
      this.idtNumber = null;
      this.isValidating = false;
      this.isSubmitting = false;
    },

    onClose() {
      this.resetModal();
      this.$emit("close");
    }
  },
  validations: {
    idtNumber: {
      required
    }
  }
};
</script>